<div class="content">
  <div class="card">
    <router-outlet />
  </div>
  <img class="img-bg" src="assets/img/Sapore.png" alt="Logo" />
</div>
